// extracted by mini-css-extract-plugin
export var divider = "_gu-7";
export var itemsToggle = "_gu-8";
export var mergeModal = "_gu-1";
export var optionCard = "_gu-4";
export var radioGroup = "_gu-6";
export var radioOption = "_gu-0";
export var selected = "_gu-5";
export var shipmentOptions = "_gu-2";
export var tableOptions = "_gu-3";